import Modal from "../../../components/atoms/Modal";
import SelectModal from "../../../components/atoms/SelectModal";
import InputGroup from "../../../components/atoms/InputGroup";
import BtnModal from "../../../components/atoms/BtnModal";
import React, {useState} from "react";
import toast from "react-hot-toast";
import {useStorehouseContext} from "../StorehouseContext";
import ViaqSelectBox from "../../../components/atoms/ViaqSelectBox";

const ChangeDeviceStatusModal = () => {
    const {
        modalState,
        closeModal,
        searchWarranty,
        updateDeviceStatus,
        activateDeviceState,activeDevice
    } = useStorehouseContext();
    const [warranty, setWarranty] = useState()
    const [factorNumber, setFactorNumber] = useState()

    const searchFunction = (props) => {

        if (props.state.value !== "") {
            searchWarranty(props)
        }

    }

    const onBtnClick =async  () => {
        if (activateDeviceState.warrantyNumber !== "" && activateDeviceState.factorNumber!=="") {
            await activeDevice()
        } else {
            toast.error("شماره گارانتی و فاکتور را وارد کنید ")
       }
    }

    const onSelectWarranty = (data) => {
        console.log("DATA : ",data)
        if (data) {
            updateDeviceStatus("warrantyNumber",data[0].value);
            // updateDeviceStatus("factorNumber");
            // handleUpdateFormValues("serialNumber", data[0].serialNumber)
            // handleUpdateFormValues("modelId", data[0].value)
        }
    }
    const isOpen = modalState.mode === "status" && modalState.isOpen;
    if (!isOpen) {
        return null;
    }
    return (
        <>
            <Modal
                title={`فعال کردن دستگاه “${modalState.selectedItem.serialNumber}”`} closeModal={closeModal}>

                <div className="flex flex-col w-379 gap-5">
                    <ViaqSelectBox
                        label="شماره گارانتی"
                        iconName="box-tick"
                        placeholder={"شماره گارانتی را انتخاب کنید"}
                        showIcon={true}
                        disabled={false}
                        defaultValue={null}
                        values={activateDeviceState.findWarranty}
                        onChange={onSelectWarranty}
                        searchFunction={searchFunction}
                        loading={activateDeviceState.searchLoading}
                    />


                    <InputGroup
                        placeholder="مانند1452456987"
                        label={"شماره فاکتور (در صورت فروش غیر الکترونیک)"}

                        iconName={"userF"}
                        onchange={(event)=>{
                            updateDeviceStatus("factorNumber",event.target.value)
                        }}
                        id={"factorN"}
                    />
                </div>

                {/*footer*/}
                <div className="flex items-center justify-end pt-5.5">
                    <BtnModal text={"فعال کردن دستگاه"} accept={onBtnClick}/>
                </div>
            </Modal>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    );
}
export default ChangeDeviceStatusModal